// src/components/14.js
import React from 'react';

const Componente14 = () => {
  return (
    <div className="component-container">
      <h2>Número de Propósito: 14</h2>
      <p>
        Para una persona nacida el día 14, el número de propósito asociado sería 14.
      </p>
      <p>
        En numerología, el número 14 está asociado con la libertad, la aventura y la exploración. Las personas nacidas en este día a menudo sienten un llamado a experimentar la vida de manera intensa y a buscar nuevas oportunidades. Su propósito puede incluir:
      </p>
      <ul>
        <li><strong>Buscar la Libertad:</strong> Estas personas valoran su independencia y buscan vivir de acuerdo con sus propias reglas.</li>
        <li><strong>Fomentar el Cambio:</strong> Pueden estar destinadas a iniciar cambios en sus vidas y en las de los demás, promoviendo la evolución y la transformación.</li>
        <li><strong>Explorar Nuevas Experiencias:</strong> Tienen un fuerte deseo de explorar el mundo, aprender cosas nuevas y expandir sus horizontes.</li>
        <li><strong>Inspirar a Otros a Ser Valientes:</strong> Su espíritu aventurero puede motivar a los demás a seguir sus propias pasiones y a vivir de manera auténtica.</li>
      </ul>

      <h3>Características del Día de Nacimiento: 14</h3>
      <ul>
        <li><strong>Aventureros:</strong> Les encanta explorar y experimentar lo desconocido.</li>
        <li><strong>Adaptables:</strong> Su capacidad para adaptarse a nuevas situaciones les permite afrontar cambios con facilidad.</li>
        <li><strong>Optimistas:</strong> Tienen una perspectiva positiva de la vida, lo que les ayuda a ver oportunidades en lugar de obstáculos.</li>
      </ul>

      <h4>Resumen</h4>
      <p>
        Las personas nacidas el día 14 son buscadores de libertad y exploradores de la vida. Su propósito se centra en fomentar el cambio y la aventura, inspirando a otros a vivir de manera auténtica y valiente. Su naturaleza adaptable y optimista les permite abrazar nuevas experiencias con entusiasmo.
      </p>
    </div>
  );
};

export default Componente14;
